import Portal from 'preact-portal'

interface Props {
  title: string
  placeHolder?: HTMLElement
}

export default function EmptyPlaceholder({ title, placeHolder }: Props) {
  if (!placeHolder) {
    return null
  }
  return (
    <Portal into={placeHolder}>
      <div className='sitewidth'>
        <div className='homepage-widget--emtpy'>{title}</div>
      </div>
    </Portal>
  )
}
